import React from "react"

export default function VisuallyHidden({ children, ...props }) {
  return (
    <span className="sr-only" {...props}>
      {children}
    </span>
  )
}
